<template>
  <div class="registerGoods">
    <!-- <div class="topBox">
      <span class="topTitle">授权作品</span>
    </div> -->
    <!-- <div class="medium">
      <el-button size="medium" type="primary">查看证书</el-button>
    </div> -->
    <el-table :data="tableData">
      <el-table-column prop="worksName" label="作品名称"></el-table-column>
      <el-table-column width="300px" prop="authSn" label="转让证书编号"></el-table-column>
      <el-table-column label="作品类型">
        <template slot-scope="scope"> 
          {{resTypeOptions.filter(val => val.value === scope.row.worksType)[0].label}}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <!-- <el-button type="text" @click="watchFile(scope.row)">查看作品文件</el-button> -->
          <el-button type="text" @click="watchCertificate(scope.row)">查看转让证书</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog 
      title="授权作品"
      :visible.sync="showDialog">
      <el-carousel indicator-position="outside">
        <el-carousel-item v-for="item in goodsList" :key="item.id">
          <img :src="fileUrl + item.works_files_path" alt="">
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { getGoodsList, getGoodFile } from '@/api/register'
import resTypeOptions from '@/utils/goodsType'
export default {
  props: ['ttopno'],
  data(){
    return{
      moment,
      resTypeOptions,
      batchNo:'',
      tableData: [],
      showDialog: false,
      fileUrl: 'https://files.wespace.cn/',
      goodsList: []
    }
  },
  created(){
    this.batchNo = this.ttopno
    this.getList()
  },
  methods:{
    getList(){
      let fd = new FormData()
      fd.append('batchNo', this.batchNo)
      getGoodsList(fd).then(res=>{
        if(res.code == 200) {
          this.tableData = res.data
        }
        console.log(res)
      }).catch(err=>{
        console.log(err)
      })
    },
    watchFile(item){
      let fd = new FormData()
      fd.append('worksId', item.worksId)
      getGoodFile(fd).then(res=>{
        console.log(res)
        if (res.code == 200) {
          this.goodsList = res.data
          this.showDialog = true
        }
        // window.open(this.fileUrl + item.authPath, '_blank')
      }).catch(err=>{
        console.log(err)
      })
    },
    watchCertificate(item){
      window.open(this.fileUrl + item.authPath, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.registerGoods{
  margin: 0 auto;
  // margin-top: 20px;
  // min-width: 1200px;
  // max-width: 1200px;
  padding: 32px;
  // padding-top: 57px;
  background: #FFFFFF;
  .topBox{
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    line-height: 24px;
    margin-bottom: 33px;
  }
  .medium{
    text-align: right;
    font-size: 12px;
    margin-bottom: 20px;
  }
}
</style>